import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { CaretLeftIconSmall, CaretRightIconSmall } from '../../../icon';
import { NakedButton } from '../../../naked';
import { TabsStyles } from '../common-styles';

type ScrollButtonProps = CommonHTMLButtonAttributes & {
  direction: 'left' | 'right';
  show: boolean;
  disabled: boolean;
};

export const ScrollButton = ({ direction, disabled, show, ...rest }: ScrollButtonProps) => {
  const scrollButtonStyles = TabsStyles.scrollArrowStyle({ disabled, direction });

  if (!show) return null;

  const IconComponent = direction === 'left' ? CaretLeftIconSmall : CaretRightIconSmall;

  return (
    <span css={scrollButtonStyles}>
      <NakedButton disabled={disabled} {...rest}>
        <IconComponent />
      </NakedButton>
    </span>
  );
};
